import React from "react";
import { Navigate } from "react-router-dom";
import { getSessionToken } from "src/helpers";

export function PrivateRoute({ children }) {
  const isLogin = getSessionToken("authToken");
  return isLogin ? children : <Navigate to="/" />;
}
